'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'diamond-half-stroke';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e5b8';
var svgPathData = ['M45.3 256L240 450.7l0-389.5L45.3 256z', 'M22.6 278.6L0 256l22.6-22.6L233.4 22.6 240 16 256 0l16 16 6.6 6.6L489.4 233.4 512 256l-22.6 22.6L278.6 489.4 272 496l-16 16-16-16-6.6-6.6L22.6 278.6zM272 450.7L466.7 256 272 61.3l0 389.5zM240 61.3L45.3 256 240 450.7l0-389.5z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamondHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;